<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Create Calamity</v-card-title>
          <v-card-text>
            <div>
              Creating calamity for {{this.selectedPotentialPackages.filter(x => x.selected).length}} out of {{this.selectedPotentialPackages.length}}
              <v-select class="calamity-reason-select" :items="calamityReasons" v-model="selectedCalamityReason"></v-select>
              <v-text-field class="calamity-reason-text" v-if="otherIsSelected()" label="Calamity Reason" v-model="title" :counter="10" required></v-text-field>
            </div>
            <div style="text-align:center">
              <v-progress-circular v-show="loading" indeterminate color="primary"></v-progress-circular>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text :disabled="loading" class="cancel-create-calamity-btn" @click="dialog=false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" class="create-calamity-btn" @click="create()" text>Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="forceTrackDialog" max-width="310" v-if="UserIsAdmin">
        <v-card>
          <v-card-title class="headline">Force Tracking Request</v-card-title>
          <v-card-text>
            <div v-if="forceTrackDialogResult">{{forceTrackDialogResult}}</div>
            <v-radio-group v-model="forceTrackingOption" v-else-if="!sendingTrackRequest">
              <v-radio :disabled="selectedCount == 0" label="Send Request For All Packages" :value="0" ></v-radio>
              <v-radio v-if="selectedCount > 0" :label="'Send Request For ' + selectedCount + ' Selected Packages.'" :value="1" ></v-radio>
            </v-radio-group>
            <v-progress-circular class="progress-circle-loading" :size="55" :width="5" indeterminate color="primary" style="left: 50%; transform: translate(-50%);" v-if="sendingTrackRequest" ></v-progress-circular>
          </v-card-text>
          <v-card-actions>
            <v-btn text :disabled="sendingTrackRequest" class="cancel-force-track-btn" @click="forceTrackDialog=false"><span v-if="forceTrackDialogResult">Close</span><span v-else>Cancel</span></v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="sendingTrackRequest" v-if="!forceTrackDialogResult" class="create-force-track-btn" @click="SendTrackRequest()" text>Send</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <a @click="goBack()">Back</a>
    <v-card>
      <v-responsive>
        <v-container grid-list-md text-xs-left>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card flat>
                <v-card-text>
                  <h2>Transit State</h2>
                  <v-layout class="transit-state-filter" row v-for="i in selectGroups('TransitState')" :key="i.key">
                    <v-icon :class="getTransitClass('TransitState', i.key) + '-icon'" style="position: relative; bottom: 10px;">label</v-icon>
                    <v-flex xs3>{{i.key}}</v-flex>
                    <v-flex xs2 class="transit-state-filter-total">{{i.items.length}}</v-flex>
                    <a><v-icon class="transit-state-filter-btn" @click="filterByTransit('TransitState', i.key)">filter_list</v-icon></a>
                    <v-checkbox class="transit-state-filter-cb" v-model="toggledTransit['TransitState'][i.key]" @change="filterByToggle($event, 'TransitState', i.key)" style="margin: 0 0 0 15px; padding: 0; height: auto;"></v-checkbox>
                  </v-layout>
                  <v-layout class="transit-state-clear-filter" row @click="clearFilter()">
                    <v-icon>label</v-icon>
                    <v-flex xs3>Total</v-flex>
                    <v-flex xs2>{{selectedPotentialPackages.length}}</v-flex>
                    <a><v-icon>clear</v-icon></a>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <v-card flat>
                <v-card-text text-xs-left>
                  <h2>Transit Status</h2>
                  <v-layout class="transit-status-filter" row v-for="i in selectGroups('TransitStatus')" :key="i.key">
                    <v-icon :class="getTransitClass('TransitStatus', i.key) + '-icon'" style="position: relative; bottom: 10px;">label</v-icon>
                    <v-flex xs3>{{i.key}}</v-flex>
                    <v-flex xs2 class="transit-status-filter-total">{{i.items.length}}</v-flex>
                    <a><v-icon  class="transit-status-filter-btn" @click="filterByTransit('TransitStatus', i.key)">filter_list</v-icon></a>
                    <v-checkbox class="transit-status-filter-cb" v-model="toggledTransit['TransitStatus'][i.key]" @change="filterByToggle($event, 'TransitStatus', i.key)" style="margin: 0 0 0 15px; padding: 0; height: auto;"></v-checkbox>
                  </v-layout>
                  <v-layout class="transit-status-clear-filter" row @click="clearFilter()">
                    <v-icon>label</v-icon>
                    <v-flex xs3>Total</v-flex>
                    <v-flex xs2>{{selectedPotentialPackages.length}}</v-flex>
                    <a><v-icon>clear</v-icon></a>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

          </v-layout>
        </v-container>

      </v-responsive>

      <v-card-title primary-title>
        <div>

          <h3 class="headline mb-0">{{selectedPotential.CurrentCity}}, {{selectedPotential.CurrentState}}</h3>
          {{selectedCount}} selected out of {{selectedPotentialPackages.length}}
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn text color="orange" class="select-all-btn" @click="selectAll()">Add {{filterCount()}}</v-btn>
        <v-btn text color="orange" class="clear-all-btn" @click="clearAll()">Clear </v-btn>
        <v-btn text color="orange" class="create-calamity-dialog-btn" :disabled="selectedPotentialPackages.filter(x => x.selected).length === 0" @click="showSaveDialog()">Create Calamity</v-btn>
        <v-btn text color="orange" class="force-track-dialog-btn" v-if="UserIsAdmin" @click="openForceTrackPackagesDialog()">Force Track</v-btn>
      </v-card-actions>
    </v-card>

    <v-data-table :mobile-breakpoint="0" class="potential-packages-data-table no-wrap-th" disable-pagination hide-default-footer :items="filteredItems" item-key="PackageId" :headers="headers" :loading="loading">
      <template v-slot:item="{ item }" item-key="HashKey">
        <tr :class="item.ProtectionState" class="potential-package">
          <td><v-checkbox class="select-cb" v-model="item.selected"></v-checkbox></td>
          <td>
            <div class="tracking-link" style="display: flex;">{{item.TrackingNumber}}<a :href="getTrackingUrl(item.TrackingNumber, item.CarrierId)" target="_blank" style="text-decoration: none; margin-left: 5px;"  v-if="getTrackingUrl(item.TrackingNumber, item.CarrierId)">
                <v-icon style="font-size: 20px;">near_me</v-icon>
              </a>
            </div>
          </td>
          <td>
            <v-chip :class="getTransitClass('TransitState', item.TransitState)">{{item.TransitState.match(/\b\w/g).join("")}}</v-chip>
          </td>
          <td>
            <v-chip :class="getTransitClass('TransitStatus', item.TransitStatus)">{{item.TransitStatus.match(/\b\w/g).join("")}}</v-chip>
          </td>
          <td>
            {{item.LastActivity}}
          </td>
          <td>
            {{item.ServiceDesc}}
          </td>
          <td>
            {{item.State}}
          </td>
          <td>
            {{item.ScheduledDeliveryDate | formatWholeDate}}
          </td>
          <td>
            {{item.OriginalScheduledDeliveryDate | formatWholeDate}}
          </td>
          <td>
            {{item.RootCauseCode}}
          </td>
        </tr>
      </template>
    </v-data-table>

  </div>
</v-slide-y-transition>
</v-container>
<!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import potentialCalamitiesReportModule, {
  POTENTIAL_CALAMITY_REPORT_NAMESPACE
} from "./store/potentialCalamityReportStore";
export default {
  name: "PotentialCalamitiesDetail",
  data() {
    return {
      title: null,
      selectedCalamityReason: null,
      calamityReasons: [
        "Mechanical Failure",
        "Late Plane",
        "Operational Delay",
        "Severe Weather",
        "Other"
      ],
      dialog: false,
      filterKey: "",
      toggledTransit: {
        TransitStatus: {},
        TransitState: {}
      },
      headers: [
        {
          text: "Add",
          value: "selected",
          sortable: false,
          align: "left",
          width: 20
        },
        {
          text: "TrackingNumber",
          value: "TrackingNumber",
          align: "left"
        },
        {
          text: "Transit State",
          value: "TransitState",
          align: "left"
        },
        {
          text: "Transit Status",
          value: "TransitStatus",
          align: "left"
        },
        {
          text: "Transit",
          value: "LastActivity",
          align: "left"
        },
        {
          text: "Shipping Service",
          value: "ServiceDesc",
          align: "left"
        },
        {
          text: "Dest. State",
          value: "State",
          align: "left"
        },
        {
          text: "Scheduled For",
          value: "ScheduledDeliveryDate",
          align: "left"
        },
        {
          text: "Originally Scheduled For",
          value: "OriginalScheduledDeliveryDate",
          align: "left"
        },
        {
          text: "Root Cause",
          value: "RootCauseCode",
          align: "left"
        }
      ],

      // Only Admin can Force Track
      UserIsAdmin: false,
      forceTrackDialog: false,
      forceTrackDialogResult: null,
      forceTrackingOption: 0
    };
  },
  computed: {
    ...mapGetters(POTENTIAL_CALAMITY_REPORT_NAMESPACE, [
      "selectedPotential",
      "selectedPotentialPackages",
      "loading",
      "transitCodes",
      "sortedTransitState",
      "sortedTransitStatus",
      "sendingTrackRequest"
    ]),
    filteredItems() {
      if (this.filterKey === "") {
        return this.selectedPotentialPackages;
      } else {
        return this.selectedPotentialPackages.filter(
          // eslint-disable-next-line
          x => this.toggledTransit[this.filterKey][x[this.filterKey]] === true
        );
      }
    },
    selectedCount() {
      return this.selectedPotentialPackages.filter(x => x.selected).length;
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(
      POTENTIAL_CALAMITY_REPORT_NAMESPACE,
      potentialCalamitiesReportModule
    );
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.CALAMITY_ADMIN]).then(
      res => {
        if (res) {
          if (this.selectedPotential.HashKey)
            this.loadPotentialCalamityPackages();
          else this.loadSelectedPotential();
          this.$isInRole([this.$roleDefs.ADMIN]).then(x => {
            this.UserIsAdmin = x;
          });
        } else this.$goHome();
      }
    );
  },
  methods: {
    openForceTrackPackagesDialog() {
      this.forceTrackDialog = true;
      this.forceTrackDialogResult = null;
      this.forceTrackingOption = 0;
    },
    SendTrackRequest() {
      var packages = [];
      this.selectedPotentialPackages.forEach(x => {
        if (x.selected || this.forceTrackingOption === 0)
          packages.push({ PackageId: x.PackageId });
      });
      if (packages.length > 0 && this.UserIsAdmin)
        return this.$store
          .dispatch(
            `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/SendTrackRequest`,
            packages
          )
          .then(res => {
            this.forceTrackDialogResult = "Request has been successfully sent.";
          })
          .catch(e => {
            console.log(e);
            this.forceTrackDialogResult = "Request has failed.";
          });
    },
    otherIsSelected() {
      if (
        this.selectedCalamityReason &&
        this.selectedCalamityReason === "Other"
      )
        return true;
      else return false;
    },
    showSaveDialog() {
      this.dialog = true;
    },
    create() {
      let title =
        this.selectedCalamityReason === "Other"
          ? this.title
          : this.selectedCalamityReason;
      let calamity = {
        title: title,
        packages: this.selectedPotentialPackages
          .filter(x => x.selected)
          .map(x => x.PackageId),
        locationId: this.selectedPotential.LocationId,
        clientId: this.selectedPotential.ClientId
      };
      return this.$store
        .dispatch(`${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/CREATE`, calamity)
        .then(res => {
          this.dialog = false;
          this.$router.push({ path: `/calamities` });
          return calamity;
        });
    },
    filterCount() {
      if (this.filterKey === "") {
        return "All";
      } else {
        return this.selectedPotentialPackages
          .filter(
            // eslint-disable-next-line
            x => this.toggledTransit[this.filterKey][x[this.filterKey]] === true
          )
          .length.toString();
      }
    },
    getTransitClass(key, transit) {
      if (this.transitCodes[key]) {
        let item = this.transitCodes[key].find(x => x.key === transit);
        if (item) return item.class;
      }
      if (key === "TransitState") return "OtherState";
      else if (key === "TransitStatus") return "OtherStatus";
    },
    selectGroups(key) {
      var packages = this.selectedPotentialPackages;
      if (key === "TransitState") packages = this.sortedTransitState;
      else if (key === "TransitStatus") packages = this.sortedTransitStatus;

      return _.chain(packages)
        .groupBy(key)
        .toPairs()
        .map(function(currentItem) {
          return _.zipObject(["key", "items", "selected"], currentItem);
        })
        .value();
    },
    selectAll() {
      this.$store.dispatch(
        `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/SELECT_ALL`,
        {
          filter: this.toggledTransit,
          filterKey: this.filterKey
        }
      );
    },
    clearAll() {
      this.$store.dispatch(`${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/CLEAR_ALL`, {
        filter: this.toggledTransit,
        filterKey: this.filterKey
      });
    },
    filterByTransit(key, label) {
      this.toggledTransit = {
        TransitStatus: {},
        TransitState: {}
      };
      this.filterKey = key;
      this.toggledTransit[key][label] = true;
    },
    filterByToggle(toggle, key, label) {
      if (this.filterKey !== key) this.filterKey = key;
      var hasFilter = false;

      for (var propertyName in this.toggledTransit[key]) {
        if (this.toggledTransit[key][propertyName] === true) {
          hasFilter = true;
        }
      }
      if (!hasFilter) this.filterKey = "";
      var temp = _.cloneDeep(this.toggledTransit);
      this.toggledTransit = { TransitStatus: {}, TransitState: {} };
      this.toggledTransit = temp;
    },
    clearFilter() {
      this.toggledTransit = {
        TransitStatus: {},
        TransitState: {}
      };
      this.filterKey = "";
    },
    goBack() {
      this.$router.go(-1);
    },
    loadSelectedPotential /* istanbul ignore next */() {
      var hashKey = window.location.href.split("/");
      hashKey = hashKey[hashKey.length - 1];
      this.$store.dispatch(
        `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/LOAD_SELECTED_POTENTIAL`,
        hashKey
      );
    },
    loadPotentialCalamityPackages() {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/LOAD_POTENTIAL_PACKAGES`,
        this.selectedPotential.HashKey
      );
    },
    getTrackingUrl(trackingNumber, carrierId) {
      switch (carrierId) {
        // UPS
        case 1:
          return (
            "http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=" +
            trackingNumber
          );
        // FEDEX
        case 2:
          return (
            "http://www.fedex.com/Tracking?action=track&tracknumbers=" +
            trackingNumber
          );
        // GSO
        case 3:
          return (
            "https://www.gso.com/Trackshipment?TrackingNumbers=" +
            trackingNumber
          );
        // USPS
        case 13:
          return (
            "https://tools.usps.com/go/TrackConfirmAction?tLabels=" +
            trackingNumber
          );
      }
      return false;
    }
  }
};
</script>
